import { createSlice } from "@reduxjs/toolkit";

const initialCustomerCategoryState = {
  listLoading: false,
  actionsLoading: false,
  lastError: null,
  customerCategories: [],
  customers: [],
  countCustomerCategories: 0
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const customerCategorySlice = createSlice({
  name: 'customerCategory',
  initialState: initialCustomerCategoryState,
  reducers: {
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    customerCategoriesFetched: (state, action) => {
      const {data} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.customerCategories = data.data ? data.data : [];
      state.countCustomerCategories = data.count ? data.count : 0
    },

    customersFetched: (state, action) => {
      const {data} = action.payload;
      state.listLoading = false;
      state.error = null;
      state.customers = data.data ? data.data : [];
    },

    catchError: (state, action) => {
      state.lastError = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    endCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.action) {
        state.actionsLoading = false;
      } else {
        state.importLoading = false;
      }
    },
  },
});
